module.exports = __webpack_public_path__ + "static/media/The Creator of My Heart.3f45b191.jpg";